import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var Meta = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment meta on ComponentPresentationMeta {\n    title\n    description\n    canonical\n  }\n"])));
export default Meta;